module.exports = __webpack_public_path__ + "img/wximg26.644f6830.png";